import { render, staticRenderFns } from "./DialogInfoIncentivos.vue?vue&type=template&id=48f59e80&lang=pug"
import script from "./DialogInfoIncentivos.vue?vue&type=script&lang=js"
export * from "./DialogInfoIncentivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports